import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GlobalActions } from 'core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './not-found.component.html'
})
export class NotFoundComponent {
    constructor() {
        GlobalActions.hideSpinner();
    }
}
